/**
 * Texts for Press Releases page
 */
export const pressReleasesPageText = {
    title: 'Persberichten - CamAPS FX',
    titleMeta: 'Persberichten - CamAPS FX',
    descriptionMeta: 'Laatste persberichten en nieuws van CamAPS FX.',
    keywords: 'camaps persberichten, camaps nieuws, diabetes technologie nieuws',
    localeMeta: 'nl_nl',

    bannerTitle: 'Persberichten',
    bannerSubtitle: 'Blijf op de hoogte van onze laatste aankondigingen',

    contactText: 'Voor persaanvragen kunt u contact opnemen via <a href="mailto:media@camdiab.com">media@camdiab.com</a>',
    pressReleasesDisclaimer: 'Alle persberichten worden in het Engels gepubliceerd.',

    download: 'Downloaden',
    showMore: 'Meer tonen',
    showLess: 'Minder tonen',
};

